import { SnackbarOrigin } from 'notistack'

export const INITIAL_ROWS_PAGE = 10
export const INITIAL_ROWS_CATALOG = 12
export const INITIAL_ROWS_MODAL_PAGE = 5
export const ROWS_PER_PAGE_OPTIONS = [5, 10, 20, 50]
export const ROWS_PER_CATALOG_OPTIONS = [8, 12, 20, 40]
export const ITEM_HEIGHT = 100
export const ITEM_PADDING_TOP = 6
export const MAXIMUM_UPLOAD_DOCUMENT_SIZE = 10000000 // 10MB
export const ENQUEUE_SNACKBAR_ANCHOR_ORIGIN = {
  vertical: 'bottom',
  horizontal: 'center',
} as SnackbarOrigin
